module.exports = __webpack_public_path__ + "img/adv0.675c62f4.jpg";